<script setup lang="ts">
import CustomButton from "@/components/Button/Button.vue";
import { useI18n } from 'vue-i18n'; // Import i18n

const { t } = useI18n(); // Initialize i18n
</script>

<template>
  <div class="container flex flex-col justify-center items-center py-20 gap-4">
    <img src="@/assets/images/thankyou.svg" alt="thank you" class="2xl:w-[15vw] xl:w-18vw md:w-[22vw] sm:w-[35vw]">
    <h1 class="font-bold responsive-title-6 text-center">
      {{ t('thankYou') }}
    </h1>
    <div class="text-center">
      {{ t('paymentDescription') }}
    </div>
    <CustomButton @click="$router.push('/trips')" size="large" type="black" :rounded="true" class="w-fit font-semibold">
      {{ t('backToMyTrip') }}
    </CustomButton>
  </div>
</template>
